<template>
    <DCard
        :title="__('orders.show.raw_data')"
        :main-title-has-slot="true"
        padding
    >
        <template #titleHasSlot>
            <DSwitch
                color="success"
                variant="3d"
                :disabled="isInLoadingState"
                :checked="showSection"
                @update:checked="showCardSection"
            />
        </template>
        <DFormRow
            v-if="showSection"
            :label="''"
            is-vertical
        >
            <textarea
                v-if="order.rawContents !== null"
                id="raw-order-contents"
                v-model="jsonOrder"
                readonly
            />
        </DFormRow>
    </DCard>
</template>

<script setup>
import { route } from '~@/Composables/route'
import { computed, ref } from 'vue'
import { useForm } from '@inertiajs/vue3'

const props = defineProps({
    order: {
        type: Object,
        default () {
            return {}
        }
    },
    section: {
        type: String,
        default () {
            return ''
        }
    },
    showSection: {
        type: Boolean,
        default () {
            return true
        }
    },
    userListView: {
        type: Array,
        default: () => {
            return []
        }
    }
})

const jsonOrder = computed(() => JSON.stringify(props.order.rawContents, null, 4))

const emit = defineEmits(['update-list'])

const columns = ref(props.userListView)

const form = useForm({
    columns: props.userListView
})

function showCardSection (value) {
    for (const column of columns.value) {
        if (column.column === props.section) {
            column.show_column = value
        }
    }

    form.columns = flattenColumns(columns.value)

    form.post(route('settings.list-view-settings.store'))

    emit('update-list', columns.value)
}

function flattenColumns (columns) {
    if (columns.length === 0) {
        return {}
    }

    const result = {}

    for (const [key, column] of Object.entries(columns)) {
        result[key] = JSON.parse(JSON.stringify(column))
    }

    return result
}
</script>

<style lang="scss">
#raw-order-contents {
    width: 80%;
    height: 40em;
    white-space: pre; // do not break on long lines but scroll
}
</style>
